<template>
    <div
        class="teams-item"
        :class="{
            'dark-theme_fileview-listfile': isPCDarkMode == 2,
        }"
        :data-index="index"
        :key="index"
        @click="clickTeam"
        @contextmenu.prevent.stop="
            contextmenu($event);
            contextmenuEvent();
        "
    >
        <div class="file-name">
            <span class="name-tag" :style="`background:${colors[index % 6]}`">{{ item.name[0] }}</span>
            <span :title="item.name">{{ item.name }}</span>
        </div>
        <div class="file-user">{{ item.nick_name }}</div>
        <div class="file-member">{{ item.member_num }}</div>
        <div class="file-time">{{ item.updated_at }}</div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Mixins } from "vue-property-decorator";
    @Component({})
    export default class listTeam extends Vue {
        @Prop() index: number;
        @Prop() item: object;

        colors = ["#7D96B9", "#FF830F", "#FFC90E", "#24AF89", "#017FFF", "#4256D1"];

        contextmenu(e) {
            this.$emit("contextmenu", { e, item: this.item });
        }

        contextmenuEvent() {
            this.$emit("contextmenuEvent");
        }

        clickTeam(e) {
            if (e.which !== 1) return;
            let q = Object.assign({ id: (<any>this.item).id }, this.$route.query);
            this.$router.push({ path: "teams", query: q });
            this.$bus.$emit("selectTeam", (<any>this.item).id);
        }
    }
</script>

<style lang="stylus" scoped>
    .teams-item
      width: 100%;
      height: 56px;
      font-size: 14px;
      line-height 16px
      cursor: pointer;
      position: relative;
      user-select: none;
      display: flex;
      align-items: center;
      border-radius 6px
      margin-bottom 4px
      >div
          color rgba(0, 0, 0, 0.50)
          textOverflow()
          cursor default
          &:hover
                background unset
    &:hover
          background rgba(242, 244, 249, 0.60);
    .file-name
          width 40%
          padding-left 24px
          color #222 !important
    .file-user
          width 21%
    .file-member
          width 19%
    .file-time
          width 20%

    .name-tag
          display inline-block
          color #fff
          width 22px
          height 22px
          line-height 24px
          text-align center
          margin-right 8px
          border-radius 4px
          font-size 13px
</style>
